import { render } from "./AuthorSidebar.vue?vue&type=template&id=e5b7defa"
import script from "./AuthorSidebar.vue?vue&type=script&lang=js"
export * from "./AuthorSidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\market\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__